export default "__VITE_ASSET__W5bkrX$7ByP5XhrXdGkoCg__"